module.exports = __webpack_public_path__ + "static/5-eac8cc4a2e1e76372bee8d64ee844c0a.jpg";